<template>
  <div class="codemirror">
    <div ref="ace" class="ace-editor" :style="{ minHeight: displayHeight }"></div>
  </div>
</template>

<script>
import ace from "ace-builds";
import "ace-builds/src-min-noconflict/theme-sqlserver"; // 新设主题
import "ace-builds/src-min-noconflict/mode-javascript"; // 默认设置的语言模式
import "ace-builds/src-min-noconflict/mode-json"; //
import "ace-builds/src-min-noconflict/mode-css"; //
import "ace-builds/src-min-noconflict/ext-language_tools";

export default {
  name: "JsCodeEditor",
  props: {
    value: {
      type: String,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: "javascript"
    },
    userWorker: {
      // 是否开启语法检查，默认开启
      type: Boolean,
      default: true
    },
    displayHeight: {
      type: String,
      default: ""
    }
  },
  inject: ["Ace"],
  data() {
    return {
      aceEditor: null,
      themePath: "ace/theme/sqlserver", // 不导入 webpack-resolver，该模块路径会报错
      modePath: "ace/mode/javascript", // 同上
      codeValue: this.value
    };
  },
  mounted() {
    // ace.config.set('basePath', 'https://ks3-cn-beijing.ksyun.com/vform2021/ace')
    ace.config.set("basePath", "https://ks3-cn-beijing.ksyun.com/vform2021/ace-mini");

    this.addAutoCompletion(ace); // 添加自定义代码提示！！

    this.aceEditor = ace.edit(this.$refs.ace, {
      fontSize: 12, // 编辑器内字体大小
      theme: this.themePath, // 默认设置的主题
      mode: this.modePath, // 默认设置的语言模式
      tabSize: 2, // 制表符设置为2个空格大小
      readOnly: this.readonly,
      highlightActiveLine: true,
      value: this.codeValue
    });

    this.aceEditor.setOptions({
      enableBasicAutocompletion: true,
      enableSnippets: true, // 设置代码片段提示
      enableLiveAutocompletion: true // 设置自动提示
    });

    if (this.mode === "json") {
      this.setJsonMode();
    } else if (this.mode === "css") {
      this.setCssMode();
    }

    if (!this.userWorker) {
      this.aceEditor.getSession().setUseWorker(false);
    }

    // 编辑时同步数据
    this.aceEditor.getSession().on("change", (ev) => {
      // this.$emit('update:value', this.aceEditor.getValue())  // 触发更新事件, 实现.sync双向绑定！！
      this.$emit("input", this.aceEditor.getValue());
    });
  },

  methods: {
    addAutoCompletion(ace) {
      let acData = [
        { meta: "VForm API", caption: "getWidgetRef", value: "getWidgetRef()", score: 1 },
        { meta: "VForm API", caption: "getFormRef", value: "getFormRef()", score: 1 },
        { meta: "VForm API", caption: "getParentFormRef", value: "getParentFormRef()", score: 1 }
        //TODO: 待补充！！
      ];
      let langTools = ace.require("ace/ext/language_tools");
      langTools.addCompleter({
        getCompletions: function (editor, session, pos, prefix, callback) {
          if (prefix.length === 0) {
            return callback(null, []);
          } else {
            return callback(null, acData);
          }
        }
      });
    },

    setJsonMode() {
      this.aceEditor.getSession().setMode("ace/mode/json");
    },

    setCssMode() {
      this.aceEditor.getSession().setMode("ace/mode/css");
    },

    getEditorAnnotations() {
      return this.aceEditor.getSession().getAnnotations();
    },

    setValue(newValue) {
      this.aceEditor.getSession().setValue(newValue);
    }
  }
};
</script>

<style lang="less" scoped>
.codemirror {
  .ace-editor {
    min-height: 300px;
  }

  .ace-sqlserver .ace_print-margin {
    width: 0px;
  }

  .ace_editor,
  .ace_editor * {
    font-family: "Monaco", "Menlo", "Ubuntu Mono", "Droid Sans Mono", "Consolas", monospace !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    letter-spacing: 0 !important;
  }
}
</style>
